import { render, staticRenderFns } from "./cloneAnnualBudget.vue?vue&type=template&id=0fb6f84e&"
import script from "./cloneAnnualBudget.vue?vue&type=script&lang=js&"
export * from "./cloneAnnualBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports